import PropTypes from "prop-types";
import React from "react";

import Choice from "../Choice";
import { FormattedMessage } from "react-intl";
import { coalesce } from "../../../../utils/ObjectUtils";
import QuestionHeader from "./QuestionHeader";

const MatrixSingleChoice = ({
  addIndicatorToQuestion,
  addQuestionChoice,
  allIndicators,
  changeQuestionField,
  intl,
  libraryQuestion,
  loadIndicators,
  pageName,
  question,
  removeIndicatorFromQuestion,
  removeQuestionChoice,
  reorderChoice
}) => (
  <QuestionHeader
    changeQuestionField={changeQuestionField}
    pageName={pageName}
    question={question}
    intl={intl}
    addIndicatorToQuestion={addIndicatorToQuestion}
    removeIndicatorFromQuestion={removeIndicatorFromQuestion}
    loadIndicators={loadIndicators}
    allIndicators={allIndicators}
    libraryQuestion={libraryQuestion}
  >
    <h6>
      <FormattedMessage id="survey.editor.matrix.column.choices" />
    </h6>
    {question.choices.map((choice, i) => {
      const choiceName = coalesce(choice.name, choice.value);
      return (
        <Choice
          key={choiceName}
          editable={!choice.unchangeable}
          choiceName={choiceName}
          choiceText={choice.text}
          choiceKey={choice.key}
          showVisibleToggle={false}
          changeQuestionField={changeQuestionField}
          question={question}
          pageName={pageName}
          addQuestionChoice={addQuestionChoice}
          removeQuestionChoice={removeQuestionChoice}
          choiceTarget="choices"
          reorderChoice={reorderChoice}
          infoText={choice.infoText}
          choiceDescriptionVisible={choice.choiceDescriptionVisible}
          letter={65 + i}
        />
      );
    }, this)}
    <h6>
      <FormattedMessage id="survey.editor.matrix.row.choices" />
    </h6>
    {question.rows.map((choice, i) => {
      const choiceName = coalesce(choice.name, choice.value);
      return (
        <Choice
          key={choiceName}
          editable={!choice.unchangeable}
          choiceName={choiceName}
          choiceText={choice.text}
          choiceKey={choice.key}
          showVisibleToggle={false}
          changeQuestionField={changeQuestionField}
          question={question}
          pageName={pageName}
          addQuestionChoice={addQuestionChoice}
          removeQuestionChoice={removeQuestionChoice}
          choiceTarget="rows"
          reorderChoice={reorderChoice}
          infoText={choice.infoText}
          choiceDescriptionVisible={choice.choiceDescriptionVisible}
          letter={65 + i}
        />
      );
    }, this)}
  </QuestionHeader>
);

export default MatrixSingleChoice;

MatrixSingleChoice.propTypes = {
  changeQuestionField: PropTypes.func,
  pageName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array,
  addQuestionChoice: PropTypes.func,
  removeQuestionChoice: PropTypes.func,
  reorderChoice: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  loadIndicators: PropTypes.func,
  libraryQuestion: PropTypes.object
};
